export default __webpack_public_path__ + "static/mladapobuda_img4-c355f3f41e9cc6912cae4118e7ecc5a6.png";